module.exports = __webpack_public_path__ + "img/xmasParty14.f08b180a.jpg";